import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import { regularButtonCommonClasses, regularButtonVariantClasses } from "@/components/Button/regular-button-class-names";
import { SolidExclamationCircleIcon } from "@/components/Icons/components/HeroIcons/SolidExclamationCircleIcon.component";
import type { Locale } from "@/ts/locale/locale.types";
type GenericErrorMessageProps = {
  readonly reset: () => void;
  readonly locale: Locale;
};
export function GenericErrorMessage(t0) {
  const $ = _c(24);
  const {
    reset,
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex size-16 items-center justify-center rounded-full bg-red-50"><SolidExclamationCircleIcon className="size-10 text-primary" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      da: "Vi beklager, der opstod en fejl",
      de: "Wir entschuldigen uns, ein Fehler ist aufgetreten",
      en: "We apologize, an error occurred",
      no: "Vi beklager, det oppstod en feil",
      sv: "Vi ber om urs\xE4kt, ett fel uppstod"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = t2[locale];
  let t4;
  if ($[2] !== t3) {
    t4 = <h2 className="font-bold text-3xl md:text-4xl">{t3}</h2>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      da: "Vi st\xF8dte p\xE5 en uventet fejl under behandlingen af din anmodning. Vores team er blevet underrettet og vil unders\xF8ge problem.",
      de: "Wir haben einen unerwarteten Fehler bei der Bearbeitung Ihrer Anfrage festgestellt. Unser Team wurde benachrichtigt und wird das Problem untersuchen.",
      en: "We encountered an unexpected error while processing your request. Our team has been notified and will investigate the issue.",
      no: "Vi opplevde en uventet feil under behandlingen av foresp\xF8rselen din. Teamet v\xE5rt er blitt varslet og vil unders\xF8ke problemet.",
      sv: "Vi st\xF6tte p\xE5 ett ov\xE4ntat fel n\xE4r vi behandlade din beg\xE4ran. V\xE5rt team har blivit meddelat och kommer att unders\xF6ka problemet."
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = t5[locale];
  let t7;
  if ($[5] !== t6) {
    t7 = <p>{t6}</p>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      da: "Pr\xF8v at genindl\xE6se siden ved at klikke p\xE5 knappen nedenfor eller pr\xF8v igen senere.",
      de: "Versuchen Sie, die Seite neu zu laden, indem Sie auf die Schaltfl\xE4che unten klicken, oder versuchen Sie es sp\xE4ter erneut.",
      en: "Try reloading the page by clicking the button below, or try again later.",
      no: "Pr\xF8v \xE5 laste inn siden p\xE5 nytt ved \xE5 klikke p\xE5 knappen nedenfor, eller pr\xF8v igjen senere.",
      sv: "F\xF6rs\xF6k att ladda om sidan genom att klicka p\xE5 knappen nedan, eller f\xF6rs\xF6k igen senare."
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = t8[locale];
  let t10;
  if ($[8] !== t9) {
    t10 = <p>{t9}</p>;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t4 || $[12] !== t7) {
    t11 = <div className="space-y-3">{t4}{t7}{t10}</div>;
    $[10] = t10;
    $[11] = t4;
    $[12] = t7;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = clsx(regularButtonCommonClasses, regularButtonVariantClasses.primary, "w-full");
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== reset) {
    t13 = () => reset();
    $[15] = reset;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      da: "Genindl\xE6s siden",
      de: "Seite neu laden",
      en: "Reload Page",
      no: "Last inn siden p\xE5 nytt",
      sv: "Ladda om sidan"
    };
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const t15 = t14[locale];
  let t16;
  if ($[18] !== t13 || $[19] !== t15) {
    t16 = <button className={t12} onClick={t13} type="button">{t15}</button>;
    $[18] = t13;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t11 || $[22] !== t16) {
    t17 = <div className="flex w-full max-w-2xl flex-col items-center gap-8 rounded border border-silver bg-white p-6 text-center shadow-lg md:p-12">{t1}{t11}{t16}</div>;
    $[21] = t11;
    $[22] = t16;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  return t17;
}